var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDropdown',{staticClass:"base",scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('div',{staticClass:"title-wrapper"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"fa fa-angle-down text-color"})])]},proxy:true},{key:"items",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }